export const setViewTemplateDictionary = [
  {
    key: 'one_column_layout',
    en: 'One Column Layout',
    uk: 'Один стовпець',
    de: 'Einspaltiges Layout',
    fr: 'Mise en page une colonne'
  },
  {
    key: 'two_column_layout',
    en: 'Two Column Layout',
    uk: 'Два стовпці',
    de: 'Zweispaltiges Layout',
    fr: 'Mise en page deux colonnes'
  },
  {
    key: 'three_column_layout',
    en: 'Three Column Layout',
    uk: 'Три стовпці',
    de: 'Dreispaltiges Layout',
    fr: 'Mise en page trois colonnes'
  },
  {
    key: 'two_columns_with_full_row',
    en: 'Two Columns with Full Row',
    uk: 'Два стовпці з повним рядком',
    de: 'Zwei Spalten mit voller Zeile',
    fr: 'Deux colonnes avec rangée complète'
  },
  {
    key: 'four_column_layout',
    en: 'Four Column Layout',
    uk: 'Чотири стовпці',
    de: 'Vierspaltiges Layout',
    fr: 'Mise en page quatre colonnes'
  },
  {
    key: 'two_row_layout',
    en: 'Two Row Layout',
    uk: 'Два рядки',
    de: 'Zweireihiges Layout',
    fr: 'Mise en page deux rangées'
  },
  {
    key: 'three_and_two_column_layout',
    en: 'Three and Two Column Layout',
    uk: 'Три і два стовпці',
    de: 'Drei-und-Zwei-Spalten-Layout',
    fr: 'Mise en page trois et deux colonnes'
  },
  {
    key: 'full_page_layout',
    en: 'Full Page Layout',
    uk: 'Повна сторінка',
    de: 'Ganzseitiges Layout',
    fr: 'Mise en page pleine page'
  },
];
